import template from './pageLayout.html' with { type: 'html' };

export default {
	name: 'CPageLayout',
	template
};
